"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _store = _interopRequireDefault(require("./store"));

var _storeMapa = _interopRequireDefault(require("./store-mapa"));

var _cloneDeepWith = _interopRequireDefault(require("lodash/cloneDeepWith"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _orderBy = _interopRequireDefault(require("lodash/orderBy"));

var _query = require("../compiler/query");

var _reorder = require("./reorder");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MemoryStore = /*#__PURE__*/function (_Store) {
  (0, _inherits2.default)(MemoryStore, _Store);

  var _super = _createSuper(MemoryStore);

  function MemoryStore() {
    var _this;

    (0, _classCallCheck2.default)(this, MemoryStore);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'MemoryStore');
    return _this;
  }

  (0, _createClass2.default)(MemoryStore, [{
    key: "_create",
    value: function _create(props) {
      var _this2 = this;

      (0, _get2.default)((0, _getPrototypeOf2.default)(MemoryStore.prototype), "_create", this).call(this, props);
      this._docs = new _storeMapa.default();

      this._docs.on('$change', function (name, value) {
        _this2.emitChange(name + 'Doc', value);
      });
    }
  }, {
    key: "_numUnarchived",
    value: function _numUnarchived() {
      var n = 0;

      var _iterator = _createForOfIteratorHelper(this._docs.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var value = _step.value;

          if (!value.archivedAt) {
            n++;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return n;
    }
  }, {
    key: "_createDoc",
    value: function () {
      var _createDoc2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
        var fieldValues, id, order, reorder, userId, doc;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fieldValues = _ref.fieldValues, id = _ref.id, order = _ref.order, reorder = _ref.reorder;

                if (this._shouldSetToLastOrder(order, reorder)) {
                  order = this._numUnarchived();
                }

                userId = this._getUserId();
                doc = this._buildDoc({
                  fieldValues: fieldValues,
                  id: id,
                  order: order,
                  userId: userId
                });

                this._docs.set(doc.id, doc, undefined, undefined, true);

                return _context.abrupt("return", doc);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _createDoc(_x) {
        return _createDoc2.apply(this, arguments);
      }

      return _createDoc;
    }()
  }, {
    key: "_toMongoWhere",
    value: function _toMongoWhere(where) {
      return (0, _cloneDeepWith.default)(where, function (doc) {
        if (doc && doc.$iLike) {
          return {
            $regex: '^' + doc.$iLike.replace(/%/, ''),
            $options: 'i'
          };
        }
      });
    }
  }, {
    key: "_hasDoc",
    value: function () {
      var _hasDoc2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(_ref2) {
        var id;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                id = _ref2.id;
                return _context2.abrupt("return", this._docs.has(id));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _hasDoc(_x2) {
        return _hasDoc2.apply(this, arguments);
      }

      return _hasDoc;
    }()
  }, {
    key: "_getDoc",
    value: function () {
      var _getDoc2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(_ref3) {
        var id;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                id = _ref3.id;
                return _context3.abrupt("return", this._docs.get(id));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _getDoc(_x3) {
        return _getDoc2.apply(this, arguments);
      }

      return _getDoc;
    }()
  }, {
    key: "_getAllDocs",
    value: function () {
      var _getAllDocs2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(_ref4) {
        var where, showArchived, order, docs, _iterator2, _step2, doc, filtered, names, orders;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                where = _ref4.where, showArchived = _ref4.showArchived, order = _ref4.order;

                // TODO: after, first, before, last and cursors in results
                if (where) {
                  // Convert to a mongo expression and then filter
                  where = this._toMongoWhere(where);
                }

                docs = {
                  // TODO: hasNextPage will need to change once we support pagination via after, first, etc...
                  // depending on if there is still more data to get
                  pageInfo: {
                    hasNextPage: false
                  },
                  edges: []
                };
                _iterator2 = _createForOfIteratorHelper(this._docs.values());

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    doc = _step2.value;
                    filtered = where === undefined ? null : (0, _query.filter)([doc], where);

                    if ((showArchived === null || showArchived === undefined || !!doc.archivedAt === showArchived) && (where === undefined || filtered.length !== 0)) {
                      docs.edges.push({
                        node: doc
                      });
                    }
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

                if (order) {
                  // Order by properties
                  names = [];
                  orders = [];
                  order.forEach(function (order) {
                    names.push('node.' + order[0]);
                    orders.push(order[1].toLowerCase());
                  });
                  docs.edges = (0, _orderBy.default)(docs.edges, names, orders);
                }

                return _context4.abrupt("return", docs);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _getAllDocs(_x4) {
        return _getAllDocs2.apply(this, arguments);
      }

      return _getAllDocs;
    }()
  }, {
    key: "_updateDoc",
    value: function () {
      var _updateDoc2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(_ref5) {
        var id, fieldValues, order, doc;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                id = _ref5.id, fieldValues = _ref5.fieldValues, order = _ref5.order;
                // Clone the data so that we don't modify the original
                doc = (0, _cloneDeep.default)(this._docs.get(id));
                doc = this._setDoc({
                  doc: doc,
                  fieldValues: fieldValues,
                  order: order
                });

                this._docs.set(id, doc, undefined, undefined, true);

                return _context5.abrupt("return", doc);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _updateDoc(_x5) {
        return _updateDoc2.apply(this, arguments);
      }

      return _updateDoc;
    }()
  }, {
    key: "_archiveDoc",
    value: function () {
      var _archiveDoc2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(_ref6) {
        var id, doc;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                id = _ref6.id;
                // Clone the data so that we don't modify the original
                doc = (0, _cloneDeep.default)(this._docs.get(id));
                doc = this._setDoc({
                  doc: doc,
                  archivedAt: this._now(),
                  order: _reorder.Reorder.DEFAULT_ORDER
                });

                this._docs.set(id, doc, undefined, undefined, true);

                return _context6.abrupt("return", doc);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _archiveDoc(_x6) {
        return _archiveDoc2.apply(this, arguments);
      }

      return _archiveDoc;
    }()
  }, {
    key: "_restoreDoc",
    value: function () {
      var _restoreDoc2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(_ref7) {
        var id, reorder, order, doc;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                id = _ref7.id, reorder = _ref7.reorder, order = _ref7.order;

                if (this._shouldSetToLastOrder(order, reorder)) {
                  order = this._numUnarchived();
                } // Clone the data so that we don't modify the original


                doc = (0, _cloneDeep.default)(this._docs.get(id));
                doc = this._setDoc({
                  doc: doc,
                  archivedAt: null,
                  order: order
                });

                this._docs.set(id, doc, undefined, undefined, true);

                return _context7.abrupt("return", doc);

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _restoreDoc(_x7) {
        return _restoreDoc2.apply(this, arguments);
      }

      return _restoreDoc;
    }()
  }]);
  return MemoryStore;
}(_store.default);

exports.default = MemoryStore;